/* global localStorage */

import { memberService } from '../services';
import { readSession } from '../services/core/auth_session';

const authModule = {
  namespaced: true,
  state: { member: null },
  actions: {
    checkPermissionById({state}, id) {
      // console.log(state);
    },
    async fetchPermissions({ commit }) {
      const session = readSession();
      if (!session.member || !session.token?.accessToken) return;
      const result = await memberService.getMyProfile();
      const current = readSession();
      // Do not apply permissions returned for a session replaced in another tab.
      if (current.member?._id !== session.member._id ||
          current.member?.subId !== session.member.subId) return;
      const screenPermission = result?.data?.result?.screenPermission || [];
      commit('SET_SCREEN_PERMISSION', screenPermission);
    }
  },
  getters: {
    hasPermissionById: (state) => (arrId = []) => {
      const matches = (state.member?.screenPermission || []).filter(item => arrId.includes(item._id));
      if (matches.length > 0) {
        return {
          isView: matches.some(item => item.isView),
          isEdit: matches.some(item => item.isEdit),
          isDel: matches.some(item => item.isDel),
        };
      } else {
        return {
          isView: false,
          isEdit: false,
          isDel: false
        };
      }
    }
  },
  mutations: {
    SET_MEMBER (state, member) {
      state.member = member ? { ...member, screenPermission: member.screenPermission || [] } : null;
    },
    SET_SCREEN_PERMISSION(state, permissions) {
      if (state.member) state.member.screenPermission = permissions;
    }
  }
};

export default authModule;
